import './Header.css'
import Brand from '../Brand/Brand'


const Header = () => {
    return(
        <header>
            <Brand />
        </header>
    )
}

export default Header